<template>
  <div>
    <b-input-group>
      <b-dropdown
        :disabled="isDisabled"
        variant="outline-secondary"
        size="sm"
        no-caret
        class="flex-grow-1"
        menu-class="z-index-dropdown"
        toggle-class="d-flex justify-content-between align-items-center bg-white text-dark border shadow-none"
      >
        <template #button-content>
          <span class="text-truncate mr-2" :class="selectedIds.length === 0 ? 'text-muted' : 'text-dark'">
            {{ displayText }}
          </span>
          <font-awesome-icon icon="chevron-down" size="xs" class="text-muted"/>
        </template>

        <b-dropdown-form @submit.stop class="p-1">
          <b-form-input
            v-model="query"
            size="sm"
            placeholder="Поиск..."
            class="mb-2"
            autocomplete="off"
          />

          <div class="options-container">
            <b-form-checkbox-group
              v-model="selectedIds"
              @change="onSelectionChange"
              stacked
              class="text-small"
            >
              <b-form-checkbox
                v-for="option in filteredItems"
                :key="option.id"
                :value="option.id"
                class="mb-1"
              >
                {{ option.name }}
              </b-form-checkbox>
            </b-form-checkbox-group>

            <div v-if="filteredItems.length === 0" class="text-muted text-small p-2">
              Ничего не найдено
            </div>
          </div>
        </b-dropdown-form>
      </b-dropdown>

      <b-input-group-append>
        <b-button
          size="sm"
          variant="secondary"
          :disabled="selectedIds.length === 0 || isDisabled"
          @click="onClear"
        >
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
          v-if="canCreateCatalog()"
          size="sm"
          variant="success"
          :disabled="isDisabled"
          @click="showModalCatalog"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <employment-category
      v-if="isModalVisible"
      :exact-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onEmploymentCategoryCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import EmploymentCategory from "./EmploymentCategory.vue";

export default {
  name: "EmploymentCategoriesMultiSelect",
  components: { EmploymentCategory },
  mixins: [
    catalogs,
    permissions
  ],
  props: {
    isDisabled: Boolean,
    value: { type: Array, default: () => [] },
    catalogItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      query: "",
      items: [],
      selectedIds: [],
      isModalVisible: false
    };
  },
  async created() {
    if (!this.catalogItems) {
      await this.getItems();
    }
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();
      return this.items.filter(item =>
        item.name.toLowerCase().includes(lowerQuery)
      );
    },
    displayText() {
      if (this.selectedIds.length === 0) return "Вид занятости";

      const selectedNames = this.items
        .filter(i => this.selectedIds.includes(i.id))
        .map(i => i.name);

      if (selectedNames.length <= 3) return selectedNames.join(", ");

      return `Выбрано: ${selectedNames.length}`;
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.selectedIds = [...newValue];
      }, immediate: true
    },
    catalogItems: {
      handler(newValue) {
        if (newValue) {
          this.items = [...newValue];
        }
      }, immediate: true
    },
  },
  methods: {
    async getItems() {
      const result = await this.getEmploymentCategoriesSearch("");

      if (result.data != null) {
        this.items = result.data;
      } else {
        this.items = [];
      }
    },
    onSelectionChange(checkedIds) {
      this.$emit('input', checkedIds);
      this.$emit('onSelect', checkedIds);
    },
    onClear() {
      this.selectedIds = [];
      this.onSelectionChange([]);
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onEmploymentCategoryCreated(newItem) {
      this.$emit('catalog-created', newItem);
      this.isModalVisible = false;
      await this.getItems();

      if (newItem && newItem.id) {
        this.selectedIds.push(newItem.id);
        this.onSelectionChange(this.selectedIds);
      }
    },
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_EMPLOYMENT_CATEGORY_EDIT]);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/EmploymentCategories/EmploymentCategoriesMultiSelect.vue